import { Link,useLocation } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import Timetable from '../assets/images/timetable_8230595.png';

        
const Sidebar = () => {
  const userdata = localStorage.getItem('routes');
  const routes   = JSON.parse(userdata);
  const roledata = localStorage.getItem('role') != '' && localStorage.getItem('role') != 'null' ? JSON.parse(localStorage.getItem('role')) : {};


    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");
    console.warn(splitLocation);
  

//   console.log(routes);

  const routesLink = () =>{
      let emptyarr = [];
      routes.forEach(function(Value, index) {
         // console.log(Value);
         // emptyarr.push(Value);
         // emptyarr.push(
         //    <li className={"/"+splitLocation[1] === Value.eroute ? "active" : ""}>
         //      <Link key={index} to={Value.eroute} activeClassName="active">
         //      <div className="menu_icon">
         //          <i class="fa fa-cog" aria-hidden="true"></i>
         //            </div>
         //        {Value.name}
         //      </Link>
         //    </li>
         //  );

         if(Value.eroute == '/finalbillapproval' || Value.eroute == '/users' || Value.eroute == '/users' || Value.eroute == '/hrattendance' ||  Value.eroute == '/leaves' ||  Value.eroute == '/admin'){
            if(roledata.rolename == 'superadmin' || roledata.rolename == 'admin'){
                emptyarr.push((<li   key={index+'li'} className={"/"+splitLocation[1] === Value.eroute ? "active" : ""}>
                  <Link key={index} to={Value.eroute} activeClassName="active">{Value.name}</Link> <span>{'>'}</span></li>));  
            }
         }else{
             emptyarr.push((<li key={index+'li'} className={"/"+splitLocation[1] === Value.eroute ? "active" : ""}><Link key={index} to={Value.eroute} activeClassName="active">{Value.name}</Link><span>{'>'}</span></li>));  
         }
         
      });

    return emptyarr;  
  }


//   console.log(routesLink());

  return(
     <>
        <div className="sidebar">
            <h2 className="sidebar-top" style={{display:'flex',alignItems: 'flex-end'}}>
              <img src={Timetable} width='50px'/>
              &nbsp;
              <Link key='dashboarddata1' to="/dashboard" activeClassName="active" style={{fontSize:'45px'}}>
                  Timesheet 
              </Link>
            
            </h2>
            <ul className="list-unstyled sidemenu-lists-style">
            <li className={splitLocation[1] === "dashboard" ||  splitLocation[1] === "" ? "active" : ""}> <Link key='dashboarddata1' to="/dashboard" activeClassName="active">Dashboard </Link> <span>{'>'}</span></li>
           {/* <li> <Link key='dashboarddata3' to="/task">Task </Link></li> */}
            {routesLink()}
            
           </ul>
        </div>  
     </>
  );
}

export default Sidebar;